<template>
  <div class="image-quizz" :class="{ 'is-ie': $browserDetect.isIE }">
    <div class="quizz-wrapper">
      <transition name="fade">
        <div class="explanation" v-show="showExplanation" v-html="explanation"></div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="quizz" v-if="!lastStep" :key="'step' + stepIndex">
          <p class="question">
            {{ currentStep.question }}
          </p>
          <div class="answers">
            <div v-for="answer in currentStep.answers"
              :key="answer.name"
              @click="triggerAnswer(answer)"
              class="answer"
              :class="{ disabled: triedAnswers.includes(answer.name) }"
            >

              <span v-if="!triedAnswers.includes(answer.name)">{{ answer.label }}</span>
              <span v-else>{{ answer.explanation }}</span>
            </div>
          </div>
        </div>
        <div class="last-step-wrapper" v-else>
          <p>
            {{ lastStepMessage }}
          </p>
          <button class="button" @click="$emit('next')">{{ buttonLabel }}</button>
        </div>
      </transition>
    </div>
    <div class="image-wrapper">
      <div class="svg" ref="image" v-html="require(`../assets/${image}.svg?inline`)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageQuizz',
  props: {
    steps: {
      type: Array,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    lastStepMessage: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stepIndex: 0,
      showExplanation: false,
      lastStep: false,
      explanation: '',
      triedAnswers: [],
      imageLayer: 'step-initial'
    }
  },
  computed: {
    currentStep () {
      return this.steps[this.stepIndex]
    }
  },
  methods: {
    nextStep () {
      if (this.stepIndex >= this.steps.length - 1) {
        this.lastStep = true
        this.imageLayer = 'step-end'
      } else {
        this.stepIndex++
        this.triedAnswers = []
        this.imageLayer = this.currentStep.name
      }
      this.showLayer()
    },
    triggerAnswer (answer) {
      if (!this.triedAnswers.includes(answer.name)) {
        this.$emit('answer', {
          step: this.currentStep.name,
          value: answer.name
        })
        if (this.currentStep.goodAnswer === answer.name) {
          this.showExplanation = true
          this.explanation = answer.explanation
          this.nextStep()
        } else {
          this.showExplanation = false
          this.triedAnswers.push(answer.name)
        }
      }
    },
    showLayer () {
      if (this.imageLayer) {
        console.log(this.$refs.image.querySelectorAll('.step'))
        this.$refs.image.querySelectorAll('.step').forEach(step => {
          step.classList.remove('visible')
        })
        this.$refs.image.querySelector('.' + this.imageLayer).classList.add('visible')
      }
    }
  },
  mounted () {
    this.showLayer()
  }
}
</script>

<style lang="scss">
.image-quizz {
  display: flex;
  flex-grow: 1;
  .quizz-wrapper {
    width: 360px;
    padding: 20px 25px;
    background-image: linear-gradient(to right, #2d5eb5 0%, #2b5194 91%, #284b8d 100%);
    color: #fff;
    text-align: left;
    font-family: $secondary-font;
    .explanation {
      background-color: $background-color;
      padding: 20px 25px;
      font-size: 0.875rem;
      color: $primary-text-color;
    }
    .quizz {
      .question {
        font-weight: 700;
        text-align: center;
        margin: 35px 25px;
      }
      .answers {
        .answer + .answer {
          margin-top: 8px;
        }
        .answer {
          cursor: pointer;
          border: 1px solid #fff;
          border-radius: $radius;
          padding: 15px;
          text-align: center;
          font-size: 0.875rem;
          transition: $color-transition;
          &:not(.disabled):hover {
            background-color: rgba(#fff, 0.7);
            color: $primary-text-color;
          }
          &.disabled {
            cursor: default;
            border: none;
            text-align: left;
            background-image: url('../../../shared/assets/icons/croix.svg');
            background-repeat: no-repeat;
            background-position: left center;
            padding-left: 25px;
            background-size: 11px;
          }
        }
      }
    }
    .last-step-wrapper {
      p {
        font-weight: 700;
        text-align: center;
        margin: 35px 25px;
      }
      button {
        margin: 0 auto;
      }
    }
  }
  .image-wrapper {
    flex-grow: 1;
    padding: 10px;
    .svg {
      width: 100%;
      svg {
        .step {
          opacity: 0;
          transition: opacity 0.6s ease-out;
          &.visible {
            opacity: 1;
          }
        }
      }
    }
  }
  &.is-ie {
    .image-wrapper {
      .svg {
        svg {
          min-height: 540px;
        }
      }
    }
  }
}
</style>
